import Header from './components/Header';
import Hero from './components/Hero';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FAQSection />
        <IndexSection />
        <CommentsSection />
        <MediaSection />
        <ContactSection />
        <TopicsSection />
        <AboutSection />
        <AppSection />
        <UpdatesSection />
        <CardsSection />
        <RankingSection />
        <FeaturesSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}